module.exports = __webpack_public_path__ + "img/referrals-active.7f11826b.svg";